import React, { useState, useEffect } from 'react';
import { config } from '@abyss/ui/tools/config';
import { storage } from '@abyss/ui/tools/storage';
import add from 'date-fns/add';
import isAfter from 'date-fns/isAfter';
import differenceInMilliseconds from 'date-fns/differenceInMilliseconds';
import { IdleModal } from './IdleModal';
import {
  TIME_TO_IDLE_IN_MINUTES,
  RESET_TIME,
  HAS_SIGNED_OUT,
} from './constants';

export const IdleUser = () => {
  const [idleModalOpen, setIdleModalOpen] = useState(false);
  const isDisabled = config('DISABLE_IDLE_TIMEOUT');

  useEffect(() => {
    storage.local.set(HAS_SIGNED_OUT, false);
  }, []);

  const events = [
    'mousemove',
    'keydown',
    'wheel',
    'DOMMouseScroll',
    'mousewheel',
    'mousedown',
    'touchstart',
    'touchmove',
    'scroll',
    'MSPointerDown',
    'MSPointerMove',
  ];

  let idleTimer;
  let eventTimer;

  const resetTimer = (event, timeDiff) => {
    if (!eventTimer || timeDiff) {
      if (!timeDiff) {
        const newTime = add(new Date(), {
          seconds: TIME_TO_IDLE_IN_MINUTES * 60,
        });
        storage.local.set(RESET_TIME, newTime);
      }

      clearTimeout(idleTimer);
      const timeoutTime = TIME_TO_IDLE_IN_MINUTES * 60 * 1000;
      idleTimer = setTimeout(() => {
        idleTimer = null;
        // eslint-disable-next-line no-use-before-define
        onTimerIdle();
      }, timeDiff || timeoutTime);

      clearTimeout(eventTimer);
      eventTimer = setTimeout(() => {
        eventTimer = null;
      }, 10000);
    }
  };

  const addListeners = () => {
    events.forEach(e => document.addEventListener(e, resetTimer));
  };

  const removeListeners = () => {
    events.forEach(e => document.removeEventListener(e, resetTimer));
    clearTimeout(idleTimer);
    clearTimeout(eventTimer);
  };

  const onTimerIdle = () => {
    const storedTime = new Date(storage.local.get(RESET_TIME));
    const now = new Date();

    if (isAfter(storedTime, now)) {
      const timeDiff = differenceInMilliseconds(storedTime, now);
      resetTimer(null, timeDiff);
    } else {
      idleTimer = null;
      removeListeners();
      setIdleModalOpen(true);
    }
  };

  useEffect(() => {
    addListeners();
    resetTimer();

    return () => {
      removeListeners();
    };
  }, []);

  useEffect(() => {
    if (!idleModalOpen) {
      addListeners();
      resetTimer();
    }
  }, [idleModalOpen]);

  return isDisabled ? null : (
    <If condition={idleModalOpen}>
      <IdleModal
        isOpen={idleModalOpen}
        closeModal={() => setIdleModalOpen(false)}
      />
    </If>
  );
};
